import React from 'react';
import PropTypes from 'prop-types';

import {
  BUYER_MESSAGES_PATH,
  BUYER_APPLICATIONS_PATH,
  BUYER_PAYMENTS_PATH,
  BUYER_SETTINGS_PATH,
  HELP_PATH,
  PUPPY_TRAINING_PROGRAM,
  PUPPY_TRAINING_PROGRAM_LANDING
} from 'dpl/shared/constants/urls';
import {
  FancyDropdownMenuItem
} from 'dpl/components/FancyDropdown';
import { hasPuppyCollegeAccess } from 'dpl/shared/buyer/utils';
import NotificationCount from 'dpl/common/components/NotificationCount';
import SmartLink from 'dpl/components/SmartLink';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';
import { FEATURES } from 'dpl/shared/constants/features';

const IS_PLAID_SETUP_FF_ON = isFeatureEnabled(FEATURES.PLAID_SETUP);

export default function UserHeaderLoggedInBuyerMenu({
  user, totalNotificationsCount
}) {
  const puppyTrainingLink = hasPuppyCollegeAccess(user?.entitlements) ?
    PUPPY_TRAINING_PROGRAM :
    PUPPY_TRAINING_PROGRAM_LANDING;

  return (
    <>
      <FancyDropdownMenuItem itemKey="messages">
        <SmartLink
          to={ BUYER_MESSAGES_PATH }
          className="flex w-100 align-items-center pv2 ph4"
        >
          <span className="flex-auto">Messages</span>
          { Boolean(totalNotificationsCount) && (
            <NotificationCount count={ totalNotificationsCount } />
          ) }
        </SmartLink>
      </FancyDropdownMenuItem>
      <FancyDropdownMenuItem itemKey="applications">
        <SmartLink
          to={ BUYER_APPLICATIONS_PATH }
          className="w-100 db pv2 ph4"
        >
          Applications
        </SmartLink>
      </FancyDropdownMenuItem>
      <FancyDropdownMenuItem itemKey="payments">
        <SmartLink
          to={ BUYER_PAYMENTS_PATH }
          className="w-100 db pv2 ph4"
        >
          Payments
        </SmartLink>
      </FancyDropdownMenuItem>
      <FancyDropdownMenuItem itemKey="settings">
        <SmartLink
          to={ BUYER_SETTINGS_PATH }
          className="w-100 db pv2 ph4"
        >
          Account Settings
        </SmartLink>
      </FancyDropdownMenuItem>
      <FancyDropdownMenuItem itemKey="help">
        <a href={ HELP_PATH } className="w-100 db pv2 ph4">
          Help
        </a>
      </FancyDropdownMenuItem>
      {
        IS_PLAID_SETUP_FF_ON && (
          <FancyDropdownMenuItem itemKey="puppy-training">
            <a href={ puppyTrainingLink } className="w-100 db pv2 ph4">
              Puppy Training
            </a>
          </FancyDropdownMenuItem>
        )
      }
    </>
  );
}

UserHeaderLoggedInBuyerMenu.propTypes = {
  user: PropTypes.shape({
    entitlements: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  totalNotificationsCount: PropTypes.number.isRequired
};
